module.exports = __webpack_public_path__ + "img/cart_null.76bbf18b.png";